"use client";

import useSSEConnection from "@/modules/hooks/sse/useSeeConnection";

const RealtimeProvider = () => {
  const {} = useSSEConnection();

  return <></>;
};

RealtimeProvider.displayName = "RealtimeProvider";
export default RealtimeProvider;
